import Page from 'components/pages/styles'
import initRequest from 'request/styles/init'
import genderStyleRequest from 'request/styles/gender'

export async function getStaticProps() {
  const initData = await initRequest()
  initData.gender = 'woman'
  initData.genderStyles = await genderStyleRequest()
  return { props: initData, revalidate: 60 * 10 }
}

export default function Styles(initData) {
  const t = useI18n()
  const description = t('seo:styles.defaultDesc')
  const year = dayjs().year()
  const title = t.seo.title('styles', { year })
  const url = h.path.full.styles()
  return (
    <>
      <C.Head>
        { h.seo({ title, description }) }
        { h.og({
          image: {
            url: cdn('images/stylemap_v2.jpg'),
            width: 1200,
            height: 628
          }
        }) }
        { h.ldjson({
          '@context': 'http://schema.org/',
          '@type': 'BreadcrumbList',
          'itemListElement': [{
            'position': 1,
            '@type': 'ListItem',
            'item': {
              '@id': h.path.full.root(),
              'name': 'StyleMap'
            }
          }, {
            'position': 2,
            '@type': 'ListItem',
            'item': {
              '@id': url,
              'name': t('seo:styles.title', { year })
            }
          }]
        }) }
        { h.ldjson({
          '@context': 'http://schema.org/',
          '@type': 'FAQPage',
          '@id': url,
          'headline': title,
          'mainEntity': [
            {
              '@type': 'Question',
              'name': t('seo:faq.question1'),
              'acceptedAnswer': {
                '@type': 'Answer',
                'text': t('seo:faq.answer1', { url })
              }
            },
            {
              '@type': 'Question',
              'name': t('seo:faq.question2'),
              'acceptedAnswer': {
                '@type': 'Answer',
                'text': t('seo:faq.answer2', { url })
              }
            }
          ]
        }) }
      </C.Head>
      <Page initData={ initData }/>
    </>
  )
}
